export default {
    namespaced: true,
    state: () => ({
        search: '',
        executionStatus: "Expired",
        tableOptions:
        {
            page: 1,
            itemsPerPage : 15,
            sortBy : [ "controldate" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
    }),
    mutations: {
        SET_SEARCH (state, payload){
            state.search = payload;
        },
        SET_EXECUTION_STATUS (state, payload){
            state.executionStatus = payload;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        }
    },
    getters: {
        getSearch: (state) => state.search,
        getExecutionStatus: (state) => state.executionStatus,
        getTableOptions: (state) => state.tableOptions,
    }
}